import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AdalService } from 'adal-angular4';
import { SessionManagementService } from '../session-management-service/session-management.service';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(
      private router: Router,
      private adalService: AdalService,
      private sessionManagementService: SessionManagementService,
      private notificationService: NotificationService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.adalService.userInfo.token;

    req = req.clone({
      setHeaders: {
        'telemetry-session': this.sessionManagementService.getSession(),
        'telemetry-request': this.sessionManagementService.uuidFast(),
        'Authorization': `Bearer ${token}`
      },
    });

    return next.handle(req)
      .pipe(catchError((error, caught)=> {
          console.log(error);
          this.handleAuthError(error);
          return of(error);
      }) as any);
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    if (err.status !== 0) {
      //navigate /delete cookies or whatever
      const notification = [
        {error: `Error ${err.status} occurred!`},
        {error: err.error.exceptionMessage || err.message}
      ];
      this.notificationService.showError(notification);

      // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
      return of(err.message);
    }
    throw err;
  }
}